// ── Section À propos — révélation au scroll ───────────────────
// Script classique (non-module), attend l'événement "gsap-ready"
function initAbout() {
    gsap.registerPlugin(ScrollTrigger);
    var section = document.getElementById("about-section");
    if (!section) return;
    // Paragraphes + citations : reveal-line yPercent
    gsap.from(".about-section .reveal-line > span", {
        yPercent: 110,
        duration: 0.75,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
            trigger: section,
            start: "top 78%",
            once: true
        }
    });
    // Photo : légère montée + fade
    gsap.from(".about-section__photo img", {
        opacity: 0,
        y: 20,
        duration: 0.9,
        ease: "power2.out",
        scrollTrigger: {
            trigger: section,
            start: "top 78%",
            once: true
        }
    });
}
document.addEventListener("gsap-ready", function() {
    requestAnimationFrame(function() {
        requestAnimationFrame(initAbout);
    });
});

//# sourceMappingURL=index.c54d6b30.js.map
